import React, { useState } from "react";
import { AppstoreAddOutlined } from "@ant-design/icons";
import { Row, Col, Card, Button, Tooltip } from "antd";
import { useLibraryCreativesContext } from "../../../../core/components/creatives/library/useLibraryCreativesContext";


import AssignedAdGroupsTable from "../components/AssignedAdGroupsTable";
import AdUnitHeroCard from "../components/AdUnitHeroCard";
import "./../library/creativestyle.css";
import { useDeleteMedias } from "../hooks/useDeleteMedias";
import AdUnitAssignmentModal from "../components/AdUnitAssignmentModal";
import { useAssignAdUnits } from "../hooks/assignAdUnits";

import { fontSize, fontWeight, fontFamily, space, icon as iconSize, text, border } from "../../Tasks/configs/designTokens";
import { useCreativeNavigation } from "../hooks/useCreativeNavigation";

const VideoUnitDetail = () => {
  // NEW: Use centralized navigation hook instead of manual navigation logic
  const { navigateBack } = useCreativeNavigation();

  // Context and state
  const {
    orgMedia,
    adGroupCreatives,
    assignedAdGroupUnit,
    refetchMedias,
  } = useLibraryCreativesContext();

  const { handleDeleteMedias } = useDeleteMedias();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedAdGroupIds, setSelectedAdGroupIds] = useState([]);
  const { handleAssignAdUnits, assigning } = useAssignAdUnits(() => {
    setModalVisible(false);
    setSelectedAdGroupIds([]);
  });

  const selectedAdUnits = orgMedia ? [orgMedia.media] : [];
  // Exclude ad groups this creative is already assigned to — they live in the
  // "Assigned Ad Groups" table, and re-assigning is a no-op.
  const assignedAdGroupIdSet = new Set(
    (assignedAdGroupUnit || []).map(g => g.id)
  );
  const availableAdGroups = (adGroupCreatives || []).filter(
    g => !assignedAdGroupIdSet.has(g.id)
  );

  // NEW: Enhanced back navigation with intelligent fallback
  const handleBackNavigation = () => {
    navigateBack({
      mediaType: 'VIDEO',
      isAdGroup: false
    });
  };

  const handleDeleteAndRedirect = async ids => {
    try {
      await handleDeleteMedias(ids);
      await refetchMedias();
      handleBackNavigation();
    } catch (error) {
      console.error('Failed to delete media:', error);
      // Error handling is already done in handleDeleteMedias hook
    }
  };

  // Get creative name for breadcrumb
  const creativeName = orgMedia && orgMedia.media ? orgMedia.media.name : "Loading...";

  return (
    <>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        minHeight: space[16], background: '#ffffff',
        border: `1px solid ${border.light}`, borderTop: `1px solid ${border.light}`,
        padding: `0 ${space[5]}px`, flexWrap: 'nowrap',
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: space[2],
          fontFamily: fontFamily.base, fontSize: fontSize.title, fontWeight: fontWeight.semibold,
          color: text.heading, letterSpacing: '-0.01em', lineHeight: 1.2,
          overflow: 'hidden', flex: 1, minWidth: 0,
        }}>
          <AppstoreAddOutlined style={{ fontSize: iconSize.lg, flexShrink: 0 }} />
          <Tooltip title={creativeName}>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {creativeName}
            </span>
          </Tooltip>
        </div>
        <div style={{ flexShrink: 0, marginLeft: space[4] }}>
          <Button type="default" size="large" onClick={handleBackNavigation}>
            Back
          </Button>
        </div>
      </div>

      <Row gutter={[16, 16]} className="crow-whole-page">
        <Col span={24}>
          <AdUnitHeroCard
            orgMedia={orgMedia}
            isVideo={true}
            onDelete={handleDeleteAndRedirect}
            assignedGroupCount={assignedAdGroupUnit ? assignedAdGroupUnit.length : 0}
          />
        </Col>
        <Col span={24} className="ccol-ad-groups">
          <Card
            title="ASSIGNED AD GROUPS"
            extra={
              <Button type="default" onClick={() => setModalVisible(true)}>
                Assign to Ad Groups
              </Button>
            }
            className="creative-detail-card"
          >
            <AssignedAdGroupsTable assignedAdGroupUnit={assignedAdGroupUnit} />
          </Card>
          <AdUnitAssignmentModal
            open={modalVisible}
            onCancel={() => setModalVisible(false)}
            selectedAdUnits={selectedAdUnits}
            availableAdGroups={availableAdGroups}
            selectedAdGroupIds={selectedAdGroupIds}
            setSelectedAdGroupIds={setSelectedAdGroupIds}
            onAssign={() =>
              handleAssignAdUnits(
                selectedAdGroupIds,
                selectedAdUnits.map(u => u.id)
              )
            }
            assigning={assigning}
            mediaType="VIDEO"
          />
        </Col>
      </Row>
    </>
  );
};

export default VideoUnitDetail;
